<template>
  <v-app>
    <v-main>
      <title-page title="اطلاعات بار">
        <template #head-options>
          <v-icon class="px-2">mdi-refresh</v-icon>
        </template>
        <div class="pa-5 min-h-scroll"></div>

        <template #navbar>
          <v-row no-gutters>
            <v-col cols="12" class="">
              <v-btn block class="logistic-color white--text py-6"
                >پرداخت کرایه</v-btn
              >
            </v-col>
          </v-row>
        </template>
      </title-page>
    </v-main>
  </v-app>
</template>

<script>
import TitlePage from "../components/Layouts/TitlePage.vue";

export default {
  name: "LoadStatus",
  components: { TitlePage },
};
</script>
<style scoped>
@media (max-width: 960px) {
  .min-h-scroll {
    height: 75vh;
    overflow-y: scroll;
  }
}
.border {
  border: 0.5px solid rgba(0, 0, 0, 0.12);
}
</style>
